import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SORT_DESC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import Refresh from '../../../components/Refresh';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import { Close } from '@material-ui/icons';
import Paper from '@material-ui/core/Paper';

import { refreshView as refreshViewAction } from 'react-admin';
import Header from './Header';
import {
  dateToHtmlInputDate,
  getDateByDayId,
  restClient
} from '../../../common';
import DatePickers from '../../../components/DatePickers';
import EditClient from './EditClient';
import Input from '@material-ui/core/Input';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: {
        'date-from': getDateByDayId(-7).toISOString(),
        'date-to': getDateByDayId(0, true).toISOString(),
        'search' : '',
      },
      editClientOpen: false,
    };
  }

  getTitle() {
    return 'Клиенты';
  }

  onDateChangeFrom(evt) {
    const date = new Date(evt.target.value);
    date.setHours(0, 0, 0, 0);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-from': resultDate
      },
      editClientOpen: false
    });
  }

  onDateChangeTo(evt) {
    const date = new Date(evt.target.value);
    date.setHours(23, 59, 59, 999);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-to': resultDate,
      }
    });
  }

  onSearchChange(evt) {
    this.setState({
      filter: {
        ...this.state.filter,
        search: evt.target.value,
      }
    });
  }

  toggleEditClient = (open, record, needFetch = false) => () => {
    if (needFetch) {
      restClient('GET_CUSTOM', 'clients/'+record.id).then(fetchedRecord => {
        // if (fetchedRecord)
        this.setState({
            record: fetchedRecord.data,
            editClientOpen: open
          }
        );
      });
    } else {
      this.setState({
          record: record,
          editClientOpen: open
        }
      );
    }

  };

  submit = values => {
    restClient('GET_CUSTOM_POST', 'clients', values).then(res => {
      // todo refactor
      this.setState({
          // record: record,
          createClientOpen: false,
          editClientOpen: false
        }
      );
      this.props.refreshView();
    });
  };

  getCloseBtn = (click) => (
    <div onClick={click} style={{position: 'fixed', right: '22px', top: '59px', cursor: 'pointer' }}>
      <Close style={{fill: '#2c9bc3', width: '30px', height: '30px' }}/>
    </div>
  );

  render() {
    // const defaultValues = {companyId : "5b54dd4d791a93dcdc1999d7"};

    // const create = (handleSubmit) => <CreateComponent onSubmit={handleSubmit} record={defaultValues} companies={this.props.companies}/>;
    // const edit = (handleSubmit, record) => <EditComponent onSubmit={handleSubmit} record={record} companies={this.props.companies}/>;
    const editClient = (handleSubmit, record) => <EditClient onSubmit={handleSubmit} record={record} companies={this.props.companies}/>;

    const passedProps = { ...this.props };
    delete (passedProps.refreshToken);
    delete (passedProps.refreshView);

    return (
      <div className="col-wrapper">
        <SwipeableDrawer
          anchor="right"
          open={this.state.editClientOpen}
          onClose={this.toggleEditClient(false)}
          onOpen={() => {}}
          disableSwipeToOpen
          disableBackdropTransition
          PaperProps={{style:{backgroundColor: '#F9F9F9'}}}
        >
          {editClient(this.submit.bind(this), this.state.record)}
          { this.getCloseBtn(this.toggleEditClient(false)) }
        </SwipeableDrawer>

        <Paper elevation={1} style={{ height: '44px', width: '990px', margin: '6px 0px 7px 10px' }}>
           <span style={{
             fontSize: '13px', fontWeight: '400', color: '#3a3a3a', marginLeft: '11px', marginRight: '7px', display: 'inline-block', top: '4px', position: 'relative'
           }}
           >Поиск:
          </span>
          <Input
            placeholder="имя или телефон"
            name="search"
            onChange={this.onSearchChange.bind(this)}
            style={{
              // marginLeft: '20px',
              top: '5px',
              width: '215px'
            }}
            value={this.state.filter.search}
          />
            <span style={{
              fontSize: '13px',
              fontWeight: '400',
              color: '#3a3a3a',
              marginLeft: '11px',
              marginRight: '7px',
              display: 'inline-block',
              top: '4px',
              position: 'relative'
            }}
            >
                С:
            </span>
          <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-from']))} onChange={this.onDateChangeFrom.bind(this)} style={{ top: '5px', width:127 }} />
          <span style={{
            fontSize: '13px', fontWeight: '400', color: '#3a3a3a', marginLeft: '11px', marginRight: '7px', display: 'inline-block', top: '4px', position: 'relative'
          }}
          >По:
            </span>
          <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-to']))} onChange={this.onDateChangeTo.bind(this)} style={{ top: '5px', width:127 }} />

        </Paper>
        <EjectedList
          {...passedProps}
          title={this.getTitle()}
          sort={{ field: '_createdAt', order: SORT_DESC }}
          perPage={50}
          actions={<Refresh />}
          bulkActions={false}
          style={{ width: '1000px' }}
          headercomponent={Header}
          filter={this.state.filter}
          // companies={this.props.companies}
        >
          <CustomerDatagrid
            // edit={edit}
            // create={create}
            companies={this.props.companies}
            toggleEdit={this.toggleEditClient.bind(this)}
            // callcenters={this.props.callcenters}
            // roles={this.state.roles}
          />
        </EjectedList>
      </div>
    );
  }
}

export default connect(state => ({
  // companies: state.sc.companies,
  // callcenters: state.sc.callcenters,
}), {
  refreshView: refreshViewAction,
})(List);



// WEBPACK FOOTER //
// ./src/pages/company/clients/List.js